export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $(".chart-expand").on("click", function(e){
      e.preventDefault();
      var code = $(this).data('expand');
      var $codeContainer = $("." + code);
      $(this).find('i').toggleClass('fa-caret-square-right fa-caret-square-down');
      
      if ($(this).hasClass('expand')) {
        $codeContainer.toggleClass("col-md-4 col-md-12");

      } else {
        $(this).toggleClass('expand');

        $codeContainer.removeClass("col-md-4 order-2 order-3").addClass("col-md-12 order-1");
        var count = 2;
        $codeContainer.siblings(".chart-code-container").each(function(){
          $(this).removeClass("col-md-12 order-2 order-3 order-1").addClass("col-md-4 order-" + count);
          var $i = $(this).find('h3 i');

          if ($i.hasClass('fa-caret-square-down')) {
            $i.toggleClass('fa-caret-square-down fa-caret-square-right');
          }
          count++;
        });
      }
      
      

    });
  },
};
  


// WEBPACK FOOTER //
// ./scripts/routes/archive.js